import { NestedGame } from "@/types/serializers"

const getGameTitle = (game: NestedGame) => {
  if (game.draft) return "Draft game"
  if (game.title) return game.title
  if (game.white_player?.name && game.black_player?.name) {
    return `${game.white_player.name} - ${game.black_player.name}`
  }
  return "Untitled game"
}

export default getGameTitle
